var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaid9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#263D4B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,0.2C22.6,0.2,0.3,22.5,0.3,50S22.6,99.7,50,99.7S99.8,77.4,99.8,50S77.5,0.2,50,0.2z M50,96.4 C24.4,96.4,3.6,75.6,3.6,50S24.4,3.5,50,3.5S96.5,24.4,96.5,50S75.6,96.4,50,96.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,21.3l-2.3-2.4c-1,1-2,2-2.9,3l2.5,2.2C20.6,23.2,21.5,22.2,22.4,21.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,46.5l3.3,0.3c0.6-7.1,3-13.9,7.2-19.8l-2.7-1.9C10.3,31.4,7.7,38.8,7,46.5L7,46.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.2,17.3c0-4-3.2-7.2-7.2-7.2c-3.4,0-6.3,2.3-7,5.6c-0.3,1.3-0.5,2.5-0.7,3.8c-2.7-0.7-5.5-1.1-8.3-1.1v-8.3 h-3.3v19.9c0,1.8-0.6,3.5-1.7,5c-0.5,0.6-1.1,1.2-1.7,1.7c-2.1,1.5-3.2,4-3.1,6.8l1.5,38c0,0.9-0.3,1.7-0.9,2.3 c-1.3,1.2-3.3,1.2-4.5,0c-0.6-0.6-0.9-1.4-0.9-2.3l1.2-38c0.1-2.7-1.1-5.3-3.1-6.8c-0.6-0.5-1.2-1-1.7-1.7c-1.1-1.4-1.7-3.2-1.7-5 V10.2h-3.3v18.6c-11.7,12.8-10.9,32.6,1.9,44.4c1.1,1,2.4,2,3.6,2.9l-0.2,5.5C32,85,34.8,88,38.4,88.1c3.6,0.1,6.6-2.7,6.7-6.2 c0-0.2,0-0.3,0-0.5l0-0.3c5.2,0.9,10.5,0.4,15.4-1.4l-0.1,1.5c-0.2,3.6,2.4,6.6,6,6.9c3.6,0.2,6.6-2.4,6.9-6c0-0.1,0-0.3,0-0.4V71.2 c11.1-12,11.1-30.5,0-42.5V17.3z M32.4,72c-11.8-9.4-14.1-26.5-5.1-38.6c0.7,2.4,2.2,4.6,4.2,6.1c1.2,0.9,1.8,2.4,1.8,4L32.4,72z  M60.7,76c-5,2.1-10.5,2.7-15.8,1.6l-1.4-34.2c-0.1-1.6,0.6-3.1,1.8-4c0.9-0.7,1.7-1.5,2.4-2.4c1.5-2,2.3-4.5,2.3-7v-8.3 c2.6,0,5.2,0.4,7.8,1.1c-0.7,4.9-1.1,9.8-1.1,14.7v17.3c0,0.9,0.7,1.7,1.7,1.7h3.8L60.7,76z M69.9,81.7c0,1.7-1.4,3.1-3.1,3.1 c-1.7,0-3.1-1.4-3.1-3.1c0-0.1,0-0.1,0-0.2l1.9-26.4c0.1-0.9-0.6-1.7-1.5-1.8c0,0-0.1,0-0.1,0H60V37.6c0-7.1,0.8-14.2,2.3-21.1 c0.5-2.1,2.5-3.4,4.6-2.9c1.8,0.4,3,2,3,3.8V81.7z M78.2,50c0,5.7-1.7,11.3-5,15.9V34C76.5,38.7,78.2,44.3,78.2,50z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.4,10.2h3.3v18.2h-3.3V10.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,10.2h3.3v18.2h-3.3V10.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid9);
export default __webpack_public_path__ + "static/media/paid-9.db165c6b886d968bb0615e8171bb17bb.svg";
export { ForwardRef as ReactComponent };